import { UiComponents, UnoStoreHooks, DashboardIcon } from "@simulanisindia/ui";
import { useNavigate } from "react-router-dom";
import { ClockIcon, LayoutIcon, ProjectListiIcon } from "../../Assest/icons/icons";

const { useUnoSelector } = UnoStoreHooks;
const { Sidebar: UISidebar } = UiComponents;

const Sidebar = () => {
  const navigate = useNavigate();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);

  const MainMenuItems = [];

  const menuItems = [
    // {
    //   id: 1,
    //   key: "dashboard",
    //   tooltip: "My Dashboard",
    //   icon: <DashboardIcon />,
    //   clickHandler: () => navigate(`/dashboard`),
    // },
    {
      id: 2,
      key: "modules",
      tooltip: "Project List",
      icon: <ProjectListiIcon />,
      clickHandler: () => navigate(`/modules`),
    },
  ];

  return (
    <>
      <UISidebar mainMenuItems={MainMenuItems} menuItems={menuItems} />
    </>
  );
};

export default Sidebar;
